"use client";

import { useTranslations } from "next-intl";

const TABLE_ROW_KEYS = [
	{ labelKey: "row1Label", descKey: "row1Desc" },
	{ labelKey: "row2Label", descKey: "row2Desc" },
	{ labelKey: "row3Label", descKey: "row3Desc" },
	{ labelKey: "row4Label", descKey: "row4Desc" },
	{ labelKey: "row5Label", descKey: "row5Desc" },
	{ labelKey: "row6Label", descKey: "row6Desc" },
	{ labelKey: "row7Label", descKey: "row7Desc" },
	{ labelKey: "row8Label", descKey: "row8Desc" },
	{ labelKey: "row9Label", descKey: "row9Desc" },
	{ labelKey: "row10Label", descKey: "row10Desc" },
] as const;

export default function LaserCuttingCapabilities() {
	const t = useTranslations("laserCuttingCapabilitiesSection");

	return (
		<section
			className="w-full bg-[#F6FFDE] py-8 sm:py-10 md:py-12 lg:py-16"
			aria-labelledby="laser-cutting-capabilities-heading"
		>
			<div className="container px-3 sm:px-4 md:px-6">
				<div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start lg:gap-10 xl:gap-16">
					<div className="min-w-0">
						<div className="inline-flex max-w-full flex-wrap items-end gap-3 sm:gap-4">
							<h2
								id="laser-cutting-capabilities-heading"
								className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl"
							>
								{t("title")}
							</h2>
							<span
								className="h-1 w-[4.5rem] shrink-0 rounded-none bg-[#86bc25] sm:w-24 md:w-28"
								aria-hidden
							/>
						</div>
					</div>
					<p className="text-left text-sm leading-relaxed text-black md:text-base lg:pt-0.5">{t("intro")}</p>
				</div>

				{/* 与上方标题区同宽（container 全宽），横线拉满；table-fixed + colgroup 保持两列比例 */}
				<div className="mt-10 w-full sm:mt-12 md:mt-14 lg:mt-16">
					<div className="overflow-x-auto">
						<table className="w-full table-fixed border-collapse text-left">
							<colgroup>
								<col className="w-[42%]" />
								<col className="w-[58%]" />
							</colgroup>
							<thead>
								<tr className="border-b border-[#e0e0e0]">
									<th className="pb-4 pl-[80px] pr-4 text-left align-middle text-sm font-bold text-black sm:pb-5 sm:pr-6 sm:text-base md:pr-8">
										{t("colSpecification")}
									</th>
									<th className="pb-4 pl-4 text-left align-middle text-sm font-bold text-black sm:pb-5 sm:pl-6 sm:text-base md:pl-8">
										{t("colTechnicalDescription")}
									</th>
								</tr>
							</thead>
							<tbody>
								{TABLE_ROW_KEYS.map((row) => (
									<tr key={row.labelKey} className="border-b border-[#e0e0e0]">
										<td className="py-3 pl-[80px] pr-4 align-middle text-sm font-bold text-black sm:py-4 sm:pr-6 sm:text-base md:pr-8">
											{t(row.labelKey)}
										</td>
										<td className="whitespace-pre-line break-words py-3 pl-4 align-middle text-sm font-normal leading-relaxed text-black sm:py-4 sm:pl-6 md:pl-8 md:text-base">
											{t(row.descKey)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</section>
	);
}
